import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const back = sessionStorage.getItem("kb_return") || window.location.pathname || "/admin";
    sessionStorage.removeItem("kb_return");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate(back, { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate(back, { replace: true, state: { user: data } });
      })
      .catch(() => navigate(back, { replace: true }));
  }, [navigate, setUser]);

  return null;
}
